<template>
  <div class="about-page">
    <!-- Hero Banner -->
    <section class="about-hero">
      <div class="hero-bg"></div>
      <div class="hero-content">
        <h1 class="hero-title">关于新恒丰</h1>
        <p class="hero-en-title">ABOUT XINHENGFENG</p>
      </div>
    </section>

    <!-- Sub Navigation -->
    <nav class="sub-nav">
      <div class="container">
        <ul class="sub-nav-list">
          <li
            v-for="(tab, index) in subNavTabs"
            :key="tab.id"
            :class="{ active: activeTab === index }"
            @click="scrollToSection(index)"
          >
            {{ tab.name }}
          </li>
        </ul>
      </div>
    </nav>

    <!-- 集团概览 -->
    <section id="overview" ref="section0" class="section overview-section">
      <div class="container">
        <div class="overview-wrap">
          <div class="overview-left" data-aos="fade-right">
            <div class="overview-watermark">ABOUT XINHENGFENG</div>
            <h2 class="overview-title">公司简介</h2>
            <div class="overview-divider"></div>
            <div class="overview-text">
              <p>郑州新恒丰咨询有限公司成立于1998年，是集工程咨询、投资咨询、管理咨询、规划咨询、工程造价、第三方评估、招投标咨询、政府采购咨询、技术咨询为一体的综合咨询服务企业。</p>
              <p>公司具有工程咨询甲级资信评价，通过了ISO9001:2015质量管理体系、ISO14001:2015环境管理体系、ISO45001:2020职业健康安全管理体系认证。公司技术力量雄厚，拥有各类专业技术人员260余人，其中：教授级高工36人，高级工程师58人，注册咨询工程师（投资）、一级注册建造师、一级注册造价师等各类注册执业人员160余人。</p>
              <p>公司以高质量发展为导向，秉承"诚信、创新、高效、共赢"的价值观，秉持"严谨务实、开拓进取"的精神，为客户提供全过程、全方位的咨询服务。</p>
              <p>公司已累计完成各类咨询项目3700余项，涉及总投资规模超过3000亿元。主要业务涵盖：规划咨询、政策研究、项目策划、可行性研究、投资咨询、项目评估、工程设计、项目管理、工程监理、造价咨询、招标代理、政府采购、BIM咨询、全过程工程咨询等领域。</p>
            </div>
          </div>
          <div class="overview-right" data-aos="fade-left">
            <div class="overview-image">
              <img src="/static/gy.png" alt="公司大楼" data-aos="zoom-in">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程 -->
    <section id="history" ref="section1" class="section history-section">
      <div class="container">
        <div class="section-header" data-aos="fade-up">
          <h2 class="section-title">发展历程</h2>
          <div class="section-divider"></div>
        </div>
        <div class="history-wrap">
          <div class="history-timeline">
            <div
              v-for="(period, index) in historyData"
              :key="period.years"
              class="history-period"
              data-aos="fade-up"
              :data-aos-delay="index * 120"
            >
              <div class="period-left">
                <span class="period-years">{{ period.years }}</span>
              </div>
              <div class="period-right">
                <ul class="period-events">
                  <li v-for="(event, eIdx) in period.events" :key="eIdx">
                    <span class="event-dot"></span>
                    <span class="event-text">{{ event }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉资质 -->
    <section id="honor" ref="section2" class="section honor-section">
      <div class="container">
        <div class="section-header" data-aos="fade-up">
          <h2 class="section-title">荣誉资质</h2>
          <div class="section-divider"></div>
        </div>
        <div class="honor-tabs" data-aos="fade-up">
          <span
            :class="{ active: honorTab === 0 }"
            @click="honorTab = 0"
          >项目荣誉</span>
          <span
            :class="{ active: honorTab === 1 }"
            @click="honorTab = 1"
          >资质证书</span>
        </div>
        <div class="honor-grid">
          <div
            v-for="(cert, index) in currentHonorList"
            :key="index"
            class="honor-card"
            data-aos="zoom-in"
            :data-aos-delay="(index % 3) * 120"
          >
            <div class="honor-image">
              <img :src="cert.image" :alt="cert.name">
            </div>
            <div class="honor-info">
              <h4>{{ cert.name }}</h4>
              <p>{{ cert.org }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 组织架构 -->
    <section id="structure" ref="section3" class="section structure-section">
      <div class="container">
        <div class="section-header" data-aos="fade-up">
          <h2 class="section-title">组织架构</h2>
          <div class="section-divider"></div>
        </div>
        <div class="structure-chart">
          <!-- 董事会 -->
          <div class="chart-level chart-level-1" data-aos="zoom-in">
            <div class="chart-box chart-box-top">董事会</div>
          </div>
          <!-- 第二级 -->
          <div class="chart-level chart-level-2" data-aos="fade-up" data-aos-delay="100">
            <div class="chart-box">运营支撑委员会</div>
            <div class="chart-box chart-box-main">总裁办</div>
            <div class="chart-box">民主生活委员会</div>
          </div>
          <!-- 第三级 -->
          <div class="chart-level chart-level-3" data-aos="fade-up" data-aos-delay="200">
            <div class="chart-box">行业营销中心</div>
            <div class="chart-box">管理支撑中心</div>
          </div>
          <!-- 第四级 -->
          <div class="chart-level chart-level-4" data-aos="fade-up" data-aos-delay="300">
            <div class="chart-sub-group">
              <div class="chart-box chart-box-sm">规划咨询事业部</div>
              <div class="chart-box chart-box-sm">投资咨询事业部</div>
              <div class="chart-box chart-box-sm">公众事业部</div>
              <div class="chart-box chart-box-sm">营销策划部</div>
              <div class="chart-box chart-box-sm">政企事业部</div>
              <div class="chart-box chart-box-sm">战略客户部</div>
            </div>
            <div class="chart-sub-group">
              <div class="chart-box chart-box-sm">智慧集成事业部</div>
              <div class="chart-box chart-box-sm">解决方案部</div>
              <div class="chart-box chart-box-sm">产品技术部</div>
              <div class="chart-box chart-box-sm">客户服务部</div>
              <div class="chart-box chart-box-sm">行政管理部</div>
              <div class="chart-box chart-box-sm">人力资源部</div>
              <div class="chart-box chart-box-sm">财务管理部</div>
              <div class="chart-box chart-box-sm">运营管理部</div>
            </div>
          </div>
          <!-- 第五级 -->
          <div class="chart-level chart-level-5" data-aos="fade-up" data-aos-delay="400">
            <div class="chart-box chart-box-bottom">区域营销中心</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section id="culture" ref="section4" class="section culture-section">
      <div class="culture-bg"></div>
      <div class="container">
        <div class="culture-content">
          <div class="culture-left" data-aos="fade-right">
            <div class="culture-watermark">VISION</div>
            <h2 class="culture-en-title">CORPORATE CULTURE</h2>
            <h3 class="culture-cn-title">企业文化</h3>
          </div>
          <div class="culture-right" data-aos="fade-left">
            <div class="culture-item">
              <span class="culture-label">企业价值观</span>
              <span class="culture-value">言必守信、行必务实、求必卓越、理必求真</span>
            </div>
            <div class="culture-item">
              <span class="culture-label">企业愿景</span>
              <span class="culture-value">诚信经营、规范管理，为员工提供发展平台，为社会贡献精品工程</span>
            </div>
            <div class="culture-item">
              <span class="culture-label">企业使命</span>
              <span class="culture-value">创造有公信力的品牌企业</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 领导风采 -->
    <section id="leader" ref="section5" class="section leader-section">
      <div class="container">
        <div class="section-header" data-aos="fade-up">
          <h2 class="section-title">领导风采</h2>
          <div class="section-divider"></div>
        </div>
        <div v-if="!selectedLeader" class="leader-grid">
          <div
            v-for="(leader, index) in leaders"
            :key="index"
            class="leader-card"
            data-aos="fade-up"
            :data-aos-delay="(index % 4) * 120"
            @click="selectLeader(index)"
          >
            <div class="leader-photo">
              <img :src="leader.photo" :alt="leader.name">
              <div class="leader-overlay">
                <i class="el-icon-right"></i>
              </div>
            </div>
            <div class="leader-info">
              <h3>{{ leader.name }}</h3>
              <span class="leader-position">{{ leader.position }}</span>
            </div>
          </div>
        </div>
        <div v-else class="leader-detail">
          <div class="detail-back" @click="backToList">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
          <div class="detail-wrap">
            <div class="detail-photo">
              <img :src="selectedLeader.photo" :alt="selectedLeader.name">
            </div>
            <div class="detail-info">
              <h2 class="detail-name">{{ selectedLeader.name }}</h2>
              <span class="detail-position">{{ selectedLeader.position }}</span>
            </div>
          </div>
          <div class="detail-bio">
            <p v-for="(para, idx) in selectedLeader.bio" :key="idx">{{ para }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业视频 -->
    <section id="video" ref="section6" class="section video-section">
      <div class="container">
        <div class="section-header" data-aos="fade-up">
          <h2 class="section-title">企业视频</h2>
          <div class="section-divider"></div>
        </div>
        <div class="video-wrap" data-aos="zoom-in">
          <div class="video-placeholder">
            <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20business%20handshake%20agreement%20blue%20corporate&image_size=landscape_16_9" alt="企业宣传视频" class="video-bg">
            <div class="video-overlay"></div>
            <div class="video-play-area">
              <div class="play-btn">
                <i class="el-icon-video-play"></i>
              </div>
              <span class="play-text">宣传视频</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      activeTab: 0,
      honorTab: 0,
      selectedIndex: -1,
      subNavTabs: [
        { id: 0, name: '关于我们' },
        { id: 1, name: '集团概览' },
        { id: 2, name: '发展历程' },
        { id: 3, name: '荣誉资质' },
        { id: 4, name: '组织架构' },
        { id: 5, name: '企业文化' },
        { id: 6, name: '领导风采' },
        { id: 7, name: '企业视频' }
      ],
      historyData: [
        {
          years: '21-25年',
          events: [
            '2024年10月 获得水利工程施工监理甲级资格',
            '2024年10月 获得水利工程建设环境保护资质',
            '2023年10月 荣获郑州市转型升级创新突出企业',
            '2023年9月 获得中国建设监理协会AAA级信用证书',
            '2023年9月 荣获两项"鲁班奖"',
            '2022年2月 首次同年度蝉联三项"鲁班奖"',
            '2021年2月 获得高新技术企业'
          ]
        },
        {
          years: '16-20年',
          events: [
            '2020年 完成多项省级重点工程项目',
            '2019年 通过ISO质量体系认证',
            '2018年 拓展全过程工程咨询业务',
            '2017年 成为中国工程咨询协会会员',
            '2016年 获得工程咨询甲级资质'
          ]
        },
        {
          years: '06-10年',
          events: [
            '2010年 业务拓展至中西部地区',
            '2009年 通过国家高新技术企业认定',
            '2008年 设立首个驻外分公司',
            '2007年 启动信息化管理系统建设',
            '2006年 进入政府采购咨询领域'
          ]
        },
        {
          years: '01-05年',
          events: [
            '2005年 获得工程造价咨询资质',
            '2004年 通过ISO9001质量管理体系认证',
            '2003年 开展投资咨询业务',
            '2002年 成立工程监理事业部',
            '2001年 业务范围扩展至全省'
          ]
        },
        {
          years: '98-00年',
          events: [
            '2000年 成为郑州市工程咨询协会理事单位',
            '1999年 获得工程招标代理资质',
            '1998年 公司成立，专注工程咨询业务'
          ]
        }
      ],
      honorAwards: [
        {
          name: '2023年度河南省优秀工程监理企业',
          org: '河南省建设监理协会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '工程招标投标行业诚实守信单位',
          org: '河南省建设工程招投标协会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '2024年度诚信自律建设先进单位',
          org: '河南省建设监理协会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '2023年度优秀会员单位',
          org: '河南省建设工程监理协会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '履行社会责任优秀监理企业',
          org: '河南省建设监理协会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '党团组织建设优秀监理企业',
          org: '河南省建设监理协会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        }
      ],
      honorCerts: [
        {
          name: '工程咨询单位甲级资格',
          org: '国家发展和改革委员会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '工程造价咨询企业甲级资质',
          org: '住房和城乡建设部',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '工程招标代理机构甲级资格',
          org: '国家发展和改革委员会',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: '政府采购代理机构资格',
          org: '河南省财政厅',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: 'ISO9001质量管理体系认证',
          org: '第三方认证机构',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        },
        {
          name: 'ISO14001环境管理体系认证',
          org: '第三方认证机构',
          image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=certificate%20award%20honor%20gold%20professional%20template&image_size=portrait_4_3'
        }
      ],
      leaders: [
        {
          name: '张潇',
          position: '董事长、党委书记',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20businessman%20portrait%20confident%20blue%20suit&image_size=square',
          bio: [
            '男，1965年8月生，新恒丰集团董事长。',
            '高级工程师，工程咨询行业二十余年，从业以来先后主持数百项规划、咨询、投资、工程管理、造价咨询等核心业务。秉持"匠心筑造、诚信致远"的经营理念，统筹集团多元化工程服务布局，带领团队坚守质量底线，严控项目风险，推动行业责任与担当。',
            '在工程咨询领域深耕细作，以专业能力推动集团高质量可持续发展。'
          ]
        },
        {
          name: '李明',
          position: '总经理、党委副书记',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20engineer%20portrait%20serious%20gray%20suit&image_size=square',
          bio: [
            '男，1968年3月生，新恒丰集团总经理。',
            '教授级高级工程师，国家注册咨询工程师，从事工程咨询及项目管理工作三十余年。主导完成多项省级重点工程项目，在规划咨询、投资咨询、全过程工程咨询等领域有着深厚的理论功底和丰富的实践经验。',
            '致力于推动集团数字化转型和高质量发展。'
          ]
        },
        {
          name: '王芳',
          position: '财务总监',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20businesswoman%20portrait%20elegant%20blue%20dress&image_size=square',
          bio: [
            '女，1972年6月生，新恒丰集团财务总监。',
            '高级会计师，注册会计师，从事财务管理工作二十余年。主导建立集团财务管控体系，推动财务数字化转型，为集团健康发展提供坚实的财务保障。',
            '在企业风险管理、内部控制等方面有着丰富的经验。'
          ]
        },
        {
          name: '陈伟',
          position: '业务总监',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20sales%20manager%20portrait%20friendly%20suit&image_size=square',
          bio: [
            '男，1975年11月生，新恒丰集团业务总监。',
            '高级工程师，从事工程咨询业务拓展与管理工作多年。主导集团市场营销体系建设，推动业务范围覆盖规划咨询、投资咨询、工程造价、工程监理等多个领域。',
            '秉持"以客户为中心"的服务理念，持续提升客户满意度。'
          ]
        },
        {
          name: '刘建国',
          position: '总工程师',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20senior%20engineer%20portrait%20gray%20hair%20suit&image_size=square',
          bio: [
            '男，1962年5月生，新恒丰集团总工程师。',
            '教授级高级工程师，国家优秀工程咨询师，从事工程技术工作三十余年。在工程规划、可行性研究、工程设计等领域有着深厚的造诣，主持完成多项国家级、省级重点工程项目。',
            '致力于推动集团技术创新和质量管理。'
          ]
        },
        {
          name: '赵慧敏',
          position: '副总经理',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20businesswoman%20executive%20portrait%20dark%20suit&image_size=square',
          bio: [
            '女，1978年9月生，新恒丰集团副总经理。',
            '高级工程师，注册咨询工程师（投资），从事工程咨询工作十五年。负责集团日常运营管理，推动组织效能提升和人才梯队建设。',
            '在人力资源管理、组织变革等方面有着丰富的实践经验。'
          ]
        },
        {
          name: '孙志强',
          position: '副总经理',
          photo: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=professional%20manager%20portrait%20confident%20dark%20blue%20suit&image_size=square',
          bio: [
            '男，1973年7月生，新恒丰集团副总经理。',
            '高级工程师，国家注册造价工程师，从事工程造价及项目管理工作二十余年。主导完成多项大型项目的造价咨询工作，在全过程工程咨询领域有着丰富的经验。',
            '推动集团业务创新和服务升级。'
          ]
        }
      ]
    }
  },
  computed: {
    currentHonorList() {
      return this.honorTab === 0 ? this.honorAwards : this.honorCerts
    },
    selectedLeader() {
      return this.selectedIndex >= 0 ? this.leaders[this.selectedIndex] : null
    }
  },
  methods: {
    selectLeader(index) {
      this.selectedIndex = index
      this.$nextTick(() => {
        const section = this.$refs.section5
        const top = section[0] ? section[0].offsetTop : section.offsetTop
        window.scrollTo({ top: top - 100, behavior: 'smooth' })
      })
    },
    backToList() {
      this.selectedIndex = -1
    },
    scrollToSection(index) {
      this.activeTab = index
      // index 0 是"关于我们"，滚动到页面顶部
      if (index === 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      // index 1-7 对应 section0-section6
      const sectionRefs = [
        'section0', 'section1', 'section2', 'section3',
        'section4', 'section5', 'section6'
      ]
      const ref = this.$refs[sectionRefs[index - 1]]
      if (ref) {
        const el = ref[0] || ref
        const top = el.offsetTop
        window.scrollTo({ top: top - 100, behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = ['section0', 'section1', 'section2', 'section3', 'section4', 'section5', 'section6']
      const scrollPos = window.scrollY + 120

      // 默认高亮"关于我们"
      let current = 0
      for (let i = 0; i < sections.length; i++) {
        const ref = this.$refs[sections[i]]
        if (ref) {
          const el = ref[0] || ref
          if (el.offsetTop <= scrollPos) {
            current = i + 1
          } else {
            break
          }
        }
      }
      this.activeTab = current
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  min-height: 100vh;
  background: #fff;
}

/* ===== Hero Banner ===== */
.about-hero {
  position: relative;
  height: 400px;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #0c1b3b 0%, #1a3a6e 50%, #2d5aa0 100%);
}

.hero-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(12, 27, 59, 0.85) 0%, rgba(26, 58, 110, 0.6) 100%),
    url('https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=modern%20glass%20building%20facade%20blue%20architectural%20photography&image_size=landscape_16_9') center/cover;
}

.hero-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10%;
}

.hero-title {
  font-size: 52px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
  position: relative;
  padding-left: 24px;
}

.hero-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 60px;
  background: linear-gradient(180deg, #3b82f6, #60a5fa);
  border-radius: 3px;
}

.hero-en-title {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 6px;
  font-weight: 300;
}

/* ===== Sub Navigation ===== */
.sub-nav {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 80px;
  z-index: 50;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.sub-nav-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: center;
}

.sub-nav-list li {
  padding: 18px 28px;
  font-size: 16px;
  color: #64748b;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.sub-nav-list li:hover {
  color: #1a56db;
}

.sub-nav-list li.active {
  color: #1a56db;
  font-weight: 600;
}

.sub-nav-list li.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #1a56db, #3b82f6);
  border-radius: 2px;
}

/* ===== Section Common ===== */
.section {
  padding: 80px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.section-divider {
  width: 50px;
  height: 4px;
  background: linear-gradient(90deg, #1a56db, #3b82f6);
  margin: 0 auto;
  border-radius: 2px;
}

/* ===== 集团概览 ===== */
.overview-section {
  background: #fff;
}

.overview-wrap {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  align-items: start;
}

.overview-left {
  position: relative;
}

.overview-watermark {
  position: absolute;
  top: -20px;
  left: -20px;
  font-size: 80px;
  font-weight: 800;
  color: rgba(26, 86, 219, 0.06);
  letter-spacing: 4px;
  white-space: nowrap;
  pointer-events: none;
}

.overview-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.overview-divider {
  width: 50px;
  height: 4px;
  background: linear-gradient(90deg, #1a56db, #3b82f6);
  margin-bottom: 30px;
  border-radius: 2px;
}

.overview-text {
  font-size: 15px;
  color: #475569;
  line-height: 2;

  p {
    margin-bottom: 16px;
    text-indent: 0;
  }
}

.overview-right {
  padding-top: 20px;
}

.overview-image {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 380px;
    object-fit: cover;
    display: block;
  }
}

/* ===== 发展历程 ===== */
.history-section {
  background: #f8fafc;
}

.history-wrap {
  max-width: 900px;
  margin: 0 auto;
}

.history-timeline {
  position: relative;
}

.history-period {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 40px;
  padding: 30px 0;
  position: relative;
}

.history-period::before {
  content: '';
  position: absolute;
  left: 180px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: linear-gradient(180deg, rgba(26, 86, 219, 0.3), rgba(26, 86, 219, 0.1));
}

.period-left {
  text-align: right;
  padding-right: 30px;
}

.period-years {
  font-size: 28px;
  font-weight: 700;
  color: #1a56db;
  position: relative;
}

.period-years::after {
  content: '';
  position: absolute;
  right: -37px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background: #fff;
  border: 3px solid #1a56db;
  border-radius: 50%;
}

.period-right {
  padding-left: 20px;
}

.period-events {
  list-style: none;
  padding: 0;
  margin: 0;
}

.period-events li {
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
  font-size: 15px;
  color: #475569;
  line-height: 1.7;
}

.event-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  background: #1a56db;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 14px;
}

.event-text {
  flex: 1;
}

/* ===== 荣誉资质 ===== */
.honor-section {
  background: #fff;
}

.honor-tabs {
  text-align: center;
  margin-bottom: 40px;

  span {
    display: inline-block;
    padding: 10px 30px;
    font-size: 16px;
    color: #64748b;
    cursor: pointer;
    border-radius: 30px;
    transition: all 0.3s ease;
    margin: 0 5px;
  }

  span.active {
    background: linear-gradient(135deg, #1a56db, #3b82f6);
    color: #fff;
    font-weight: 600;
  }
}

.honor-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.honor-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  }
}

.honor-image {
  padding: 20px;
  background: linear-gradient(135deg, #f0f5ff, #e8eefc);

  img {
    width: 100%;
    height: 220px;
    object-fit: contain;
    border-radius: 8px;
  }
}

.honor-info {
  padding: 20px;
  text-align: center;

  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 8px;
  }

  p {
    font-size: 13px;
    color: #64748b;
  }
}

/* ===== 组织架构 ===== */
.structure-section {
  background: #f8fafc;
}

.structure-chart {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.chart-level {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.chart-level-2 {
  margin-bottom: 40px;
}

.chart-level-4 {
  flex-direction: column;
  gap: 30px;
  align-items: stretch;
}

.chart-sub-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.chart-box {
  display: inline-block;
  padding: 14px 28px;
  background: linear-gradient(135deg, #1a56db, #3b82f6);
  color: #fff;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 15px rgba(26, 86, 219, 0.3);
}

.chart-box-main {
  padding: 18px 36px;
  font-size: 17px;
}

.chart-box-top {
  padding: 20px 60px;
  font-size: 20px;
  background: linear-gradient(135deg, #0c1b3b, #1a3a6e);
  margin-bottom: 20px;
}

.chart-box-sm {
  padding: 10px 18px;
  font-size: 13px;
  background: linear-gradient(135deg, #475569, #64748b);
  font-weight: 500;
}

.chart-box-bottom {
  background: linear-gradient(135deg, #0c1b3b, #1a3a6e);
  margin-top: 20px;
}

/* ===== 企业文化 ===== */
.culture-section {
  position: relative;
  overflow: hidden;
  padding: 100px 0;
}

.culture-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #1e3a5f 0%, #0c1b3b 100%);
}

.culture-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(30, 58, 95, 0.3) 0%, rgba(12, 27, 59, 0.5) 100%),
    url('https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=snowy%20mountain%20landscape%20blue%20sky%20beautiful%20nature&image_size=landscape_16_9') center/cover;
}

.culture-content {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.culture-left {
  color: #fff;
}

.culture-watermark {
  font-size: 100px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.08);
  letter-spacing: 8px;
  position: absolute;
  top: -40px;
  left: -20px;
  white-space: nowrap;
}

.culture-en-title {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 4px;
  margin-bottom: 12px;
}

.culture-cn-title {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
}

.culture-right {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.culture-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: translateY(-4px);
  }
}

.culture-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.culture-value {
  font-size: 17px;
  color: #fff;
  font-weight: 500;
  line-height: 1.7;
}

/* ===== 领导风采 ===== */
.leader-section {
  background: #fff;
}

.leader-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.leader-card {
  text-align: left;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    .leader-overlay {
      opacity: 1;
    }

    .leader-info {
      h3 {
        color: #1a56db;
      }
    }
  }
}

.leader-photo {
  width: 100%;
  padding-top: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  margin-bottom: 16px;
  background: #f1f5f9;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .leader-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(26, 86, 219, 0.75), rgba(59, 130, 246, 0.6));
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 20px;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 12px;
    pointer-events: none;

    i {
      width: 44px;
      height: 44px;
      background: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #1a56db;
      font-weight: bold;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
}

.leader-info {
  padding: 0 4px;
  transition: all 0.3s ease;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 6px;
    transition: color 0.3s ease;
  }

  .leader-position {
    font-size: 14px;
    color: #64748b;
  }
}

.leader-detail {
  max-width: 1000px;
  margin: 0 auto;
}

.detail-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  color: #475569;
  transition: all 0.3s ease;
  margin-bottom: 40px;

  i {
    font-size: 14px;
  }

  &:hover {
    border-color: #1a56db;
    color: #1a56db;
    background: rgba(26, 86, 219, 0.05);
  }
}

.detail-wrap {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 60px;
  margin-bottom: 40px;
}

.detail-photo {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    display: block;
  }
}

.detail-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.detail-name {
  font-size: 36px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.detail-position {
  font-size: 18px;
  color: #64748b;
  font-weight: 500;
  padding-left: 20px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px;
    background: linear-gradient(180deg, #1a56db, #3b82f6);
    border-radius: 2px;
  }
}

.detail-bio {
  padding-top: 30px;
  border-top: 1px solid #e2e8f0;

  p {
    font-size: 15px;
    color: #475569;
    line-height: 2;
    margin-bottom: 16px;
    text-indent: 2em;
  }
}

/* ===== 企业视频 ===== */
.video-section {
  background: #f8fafc;
}

.video-wrap {
  max-width: 1100px;
  margin: 0 auto;
}

.video-placeholder {
  position: relative;
  height: 520px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);

  .video-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .video-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(12, 27, 59, 0.5), rgba(26, 58, 110, 0.4));
  }

  .video-play-area {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    transition: transform 0.3s ease;

    .play-btn {
      width: 90px;
      height: 90px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
      transition: all 0.3s ease;

      i {
        font-size: 36px;
        color: #1a56db;
        margin-left: 6px;
      }
    }

    .play-text {
      font-size: 22px;
      color: #fff;
      letter-spacing: 6px;
      font-weight: 500;
    }
  }

  &:hover {
    .video-play-area {
      transform: scale(1.05);
    }

    .play-btn {
      transform: scale(1.1);
      background: #fff;
    }
  }
}



/* ===== Responsive ===== */
@media (max-width: 992px) {
  .hero-content {
    padding-left: 5%;
  }

  .hero-title {
    font-size: 40px;
  }

  .overview-wrap {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .overview-image img {
    height: 300px;
  }

  .history-period {
    grid-template-columns: 140px 1fr;
    gap: 20px;
  }

  .honor-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .leader-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .detail-wrap {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .detail-photo img {
    height: 320px;
  }

  .video-placeholder {
    height: 400px;
  }

  .culture-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-links-group {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .about-hero {
    height: 300px;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-en-title {
    font-size: 16px;
    letter-spacing: 4px;
  }

  .sub-nav-list {
    overflow-x: auto;
    justify-content: flex-start;
    -webkit-overflow-scrolling: touch;
  }

  .sub-nav-list li {
    padding: 14px 16px;
    font-size: 14px;
    flex-shrink: 0;
  }

  .section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 28px;
  }

  .history-period {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .period-left {
    text-align: left;
    padding-right: 0;
  }

  .period-years::after {
    display: none;
  }

  .honor-grid {
    grid-template-columns: 1fr;
  }

  .leader-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .detail-name {
    font-size: 28px;
  }

  .detail-photo img {
    height: 280px;
  }

  .video-placeholder {
    height: 300px;
  }

  .play-text {
    font-size: 18px;
    letter-spacing: 4px;
  }

  .chart-level-4 .chart-sub-group {
    gap: 8px;
  }

  .chart-box-sm {
    font-size: 12px;
    padding: 8px 14px;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
  }

  .footer-bottom-bar {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}

/* ===== 移动端补充(与 64px Header 同步) ===== */
@media (max-width: 768px) {
  .sub-nav {
    top: 64px;
  }

  .sub-nav-list {
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .overview-watermark {
    font-size: 48px;
    top: -10px;
    left: -10px;
  }

  .culture-watermark {
    font-size: 60px;
    top: -20px;
  }

  .period-years {
    font-size: 24px;
  }
}

/* ===== 小屏手机适配 ===== */
@media (max-width: 480px) {
  .about-hero {
    height: 240px;
  }

  .hero-content {
    padding-left: 20px;
  }

  .hero-title {
    font-size: 24px;
    padding-left: 16px;

    &::before {
      height: 40px;
      width: 4px;
    }
  }

  .hero-en-title {
    font-size: 13px;
    letter-spacing: 3px;
  }

  .section {
    padding: 50px 0;
  }

  .section-title {
    font-size: 24px;
  }

  .overview-title {
    font-size: 26px;
  }

  .overview-watermark,
  .culture-watermark {
    display: none;
  }

  .overview-image img {
    height: 220px;
  }

  .overview-text {
    font-size: 14px;
    line-height: 1.8;

    p {
      margin-bottom: 12px;
    }
  }

  .period-years {
    font-size: 20px;
  }

  .period-events li {
    font-size: 13px;
  }

  .honor-tabs span {
    padding: 8px 20px;
    font-size: 14px;
  }

  .honor-image img {
    height: 160px;
  }

  .chart-box {
    padding: 10px 18px;
    font-size: 13px;
  }

  .chart-box-top {
    padding: 14px 30px;
    font-size: 16px;
  }

  .chart-box-sm {
    padding: 7px 10px;
    font-size: 11px;
  }

  .culture-cn-title {
    font-size: 28px;
  }

  .culture-item {
    padding: 16px 18px;
  }

  .culture-value {
    font-size: 15px;
  }

  .leader-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .leader-info h3 {
    font-size: 18px;
  }

  .detail-name {
    font-size: 24px;
  }

  .detail-position {
    font-size: 15px;
  }

  .detail-photo img {
    height: 240px;
  }

  .detail-bio p {
    font-size: 14px;
    line-height: 1.9;
  }

  .video-placeholder {
    height: 240px;
  }

  .play-btn {
    width: 64px;
    height: 64px;

    i {
      font-size: 26px;
    }
  }

  .play-text {
    font-size: 16px;
    letter-spacing: 3px;
  }
}
</style>
